export const InterestOptions = {
    greeklife: "Greek Life",
    athletics: "Athletics",
    politics: "Politics",
    religious: "Religious",
    art: "Art",
    mensclub: "Men's Club",
    womensclub: "Women's Club",
    issueAdvocate: "Issue Advocate",
    resLife: "Residential Life",
    other: "Other"
}
